module.exports = __webpack_public_path__ + "media/packs/images/flags/PY-87698ba1f9d1d0ec0f1bdf1482015a40.png";